import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagUY = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M25 18.478h24.139a24.861 24.861 0 0 0-2.808-6.522H25v6.522ZM9.437 44.565h31.125a25.127 25.127 0 0 0 5.768-6.521H3.67a25.131 25.131 0 0 0 5.768 6.521ZM25 0v5.435h15.562A24.893 24.893 0 0 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M25 18.478h24.139a24.861 24.861 0 0 0-2.808-6.522H25v6.522ZM0 25c0 2.256.3 4.442.861 6.522H49.14c.56-2.08.861-4.265.861-6.522H0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m21.739 14.631-3.053 1.436 1.625 2.957-3.315-.634-.42 3.35-2.31-2.464-2.309 2.463-.42-3.349-3.315.634 1.626-2.957-3.053-1.436 3.053-1.436-1.626-2.957 3.315.634.42-3.349 2.31 2.463 2.309-2.463.42 3.35 3.316-.635-1.626 2.957 3.053 1.436Z"
}));
FlagUY.displayName = 'FlagUY';
export default withFlagWrapper(FlagUY);
//# sourceMappingURL=index.js.map